import { initLocalization } from '@adsk/alloy-react-localization';

const getLocale = (language: string) => {
  // eslint-disable-next-line no-unsanitized/method
  return import(`./locales/${language}.json`);
};

const { useTranslation, withTranslation } = initLocalization({
  getLocale,
});

export { useTranslation, withTranslation };
